// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__ovu4p","header":"Messages_header__2Mx6Y"};